import client from '@libs/HttpClient';
const moment = require('moment');

class UserSkillsScoreService {
  static listUserSkillsScoreService(request) {
    const userId = request.id;
    const page_no = request.page_no;
    const searchText = request.searchText;
    return client.get(
      `/user/view/${userId}/user-skills-score?search=${searchText}&page=${page_no}`,
      request
    );
  }
  static deleteUserSkillsScoreService(userSkillsScoreId) {
    return client.delete(`/user/user-skills-scores/parameter/view-progress/${userSkillsScoreId}`);
  }
  static addUserSkillsScoreService(request) {
    const userId = request.user_id;
    request.start_date = moment(request.start_date).format('YYYY-MM-DD');
    request.end_date =
      request.end_date != '' && request.end_date != null
        ? moment(request.end_date).format('YYYY-MM-DD')
        : '';
    return client.post(`/user/view/${userId}/user-skills-scores`, request);
  }
  static updateUserSkillsScoreService(request) {
    const userSkillsScoresId = request.user_skills_scores_id;
    request.start_date = moment(request.start_date).format('YYYY-MM-DD');
    request.end_date =
      request.end_date != '' && request.end_date != null
        ? moment(request.end_date).format('YYYY-MM-DD')
        : '';
    return client.put(`/user/user-skills-scores/parameter/view-progress/${userSkillsScoresId}`, request);
  }
  static viewUserSkillsScoreService(userId, id) {
    return client.get(`/user/view/${userId}/user-skills-scores/${id}/edit`);
  }
  // static sprintStatusTypes() {
  //   return client.get('/get-sprint-status-type');
  // }
  
  // Fetch all active skill scoring parameters
  static getSkillParametersListService(type) {
    const params = {};
    if (type) params.type = type;

    return client.get('/user-skills-scores/parameter-list', { params });
  }

  // Fetch all options related to a specific skill scoring parameter
  static getSkillScoringOptionsService(skillId) {
    return client.get(`/user-skills-scores/parameter/${skillId}/options`);
  }
 
  // Fetch all options related to a specific skill scoring parameter
  static getSkillScoringProgress(userId, skillScoringParametersId) {
    return client.get(`/user/view/${userId}/user-skills-score/${skillScoringParametersId}`);
  }
}
export { UserSkillsScoreService };

